import type { ApplicationNotification, NotificationAction, NotificationAdapter } from "../notifications-panel.types";

const emptyNotificationActions: NotificationAction[] = [];

const getNotificationActions = (notification: ApplicationNotification): NotificationAction[] => {
  if (notification.actions?.length) {
    return notification.actions;
  }

  if (notification.link) {
    return [{ payload: notification.link, title: "Перейти", type: "link" }];
  }

  return emptyNotificationActions;
};

export const createDefaultNotificationAdapter = (notification: ApplicationNotification): NotificationAdapter => ({
  getActions: () => getNotificationActions(notification),
  getBody: () => ({ body: notification.description ?? notification.name, canShowButton: true }),
  getTitle: () => notification.title ?? "Уведомление",
});
